import { render, staticRenderFns } from "./SubCommitteeApprove.vue?vue&type=template&id=2f4a766a&"
import script from "./SubCommitteeApprove.vue?vue&type=script&lang=js&"
export * from "./SubCommitteeApprove.vue?vue&type=script&lang=js&"
import style0 from "./SubCommitteeApprove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports